import { urlConfig } from "../../config/urlConfig";
import { postCall, postFileDownloadCall } from "../httpService";

const GroupsGet = urlConfig.GroupsGet;
const ExcelGet = urlConfig.ExcelGet;
const GetGroupsDataEdit = urlConfig.GetGroupsDataEdit;
const GetRoleData = urlConfig.GetRoleData;
const GetAccountName = urlConfig.GetAccountName;
const CreateGroups = urlConfig.CreateGroups;
const GroupIDExists = urlConfig.GroupIDExists;
const GroupStatusChange = urlConfig.GroupStatusChange

export const getGroupsData = async (params: any) => {
  try {
    const response = await postCall(GroupsGet, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getExcelData = async (params: any) => {
    try {
        const response = await postFileDownloadCall(ExcelGet, params);
        return response.data;
    } catch (error) {
        console.log("Error in DownloadEmailTemplate ", error);
        throw error;
    }
};

export const getGroupsDataEdit = async (params: any) => {
  try {
    const response = await postCall(GetGroupsDataEdit, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getRoles = async (params: any) => {
  try {
    const response = await postCall(GetRoleData, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getAccounts = async (params: any) => {
  try {
    const response = await postCall(GetAccountName, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const createGroups = async (params: any) => {
  try {
    const response = await postCall(CreateGroups, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const groupIDExists = async (params: any) => {
  try {
    const response = await postCall(GroupIDExists, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const groupStatusChange = async (params: any) => {
  try {
    const response = await postCall(GroupStatusChange, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
